export var PASSENGER_FIELD_PREFIX = 'passenger_';
export var SEGMENT_FIELD_PREFIX = 'segment_';
export var ALL_FLIGHTS_FIELD = 'allFlights';
export var ALL_PASSENGERS_FIELD = 'allPassengers';
